"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainTabsView = MainTabsView;
const React = __importStar(require("react"));
const Elements = __importStar(require("../elements"));
const Guid = __importStar(require("@genesys/shared/lib/guid"));
function MainTabsView(props) {
    if (!props.tabs) {
        throw new Error("Tabs undefined");
    }
    return (React.createElement(Elements.TabNav, null, props.tabs.map(x => (React.createElement(Elements.TabNavItem, { active: !!(props.selectedTab && Guid.guidEquals(props.selectedTab, x.id)), key: `tab_${Guid.guidToString(x.id)}` },
        React.createElement("a", { onClick: () => props.activateTab(x) },
            x.title,
            React.createElement(Elements.CloseButton, { dummy: "asd", onClick: (e) => {
                    e.bubbles = false;
                    e.stopPropagation();
                    props.removeTab(x);
                } })))))));
}
//# sourceMappingURL=main-tabs-view.js.map